import { render, staticRenderFns } from "./label-pengiriman.vue?vue&type=template&id=16c753bd&scoped=true&"
import script from "./label-pengiriman.vue?vue&type=script&lang=js&"
export * from "./label-pengiriman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c753bd",
  null
  
)

export default component.exports